<template>
  <div class="developer-incoming-files">
    <BaseContainer
      :active-spacer="true"
      :permission-list="['admin']"
    >
      <template v-slot:header-title>
        Preview de Dashboards
      </template>
      <template v-slot:header-title-description>
        Preview interno do motor de <b>Dashboards dinâmicos</b>
      </template>
      <div class="app-align-items-center">
        <BaseInput
          v-model="modelScreen"
          label="Tela"
          hint="Preencha com o viewId"
          persistent-hint
          class="my-4 mr-4"
        />
        <BaseDatePicker
          name-placeholder="Data"
          :date-value="modelReferenceDate"
          :max-width="118"
          locale="pt-br"
          time-zone="UTC"
          @on-input-date-picker="(value) => { modelReferenceDate = value }"
        />
        <BaseButton
          type="text"
          color="primary"
          :is-disabled="!modelReferenceDate || !modelScreen"
          @click="getScreenList()"
        >
          Buscar
        </BaseButton>
      </div>
      <BaseCodemirror
        ref="dashboard-preview-json"
        v-model="jsonInput"
        cm-ref="dashboard-preview-json"
        title="JSON da tela - Cole um JSON ou utilize os filtros pra renderizar a tela."
        lang="json"
        :cm-height="360"
        class="mb-4"
      />
      <v-alert
        v-if="parseError"
        type="error"
        dense
        text
      >
        JSON inválido: {{ parseError }}
      </v-alert>
      <DashboardScreen
        v-else-if="currentScreen"
        :key="screenRenderKey"
        class="my-12"
        :screen="currentScreen"
        @row-detail="onRowDetail"
        @input="onDrawerInput"
        @filter-change="onFilterChange"
        @update:options="onTableOptionsChange"
        @update:reference-date="onReferenceDateChange"
        @submit="onFilterSubmit"
        @action="onAction"
      />
      <BaseDetailDrawer
        v-for="entry in openIndependentDrawersList"
        :key="entry.id"
        :value="true"
        :title="entry.row.detail.props.title || ''"
        :subtitle="entry.row.detail.props.subtitle || ''"
        :width="entry.row.detail.props.width"
        @input="(value) => onIndependentDrawerInput(entry.id, value)"
      >
        <DashboardLazyRef
          v-if="entry.row.detail.type === 'lazy_ref'"
          :instance="entry.row.detail.props.instance"
          :params="entry.row.detail.props.params"
          :view="modelScreen"
          @row-detail="onRowDetail"
          @filter-change="onFilterChange"
          @update:options="onTableOptionsChange"
          @submit="onFilterSubmit"
          @action="onAction"
        />
        <template v-else>
          <DashboardNodeRenderer
            v-for="(child, index) in (entry.row.detail.children || [])"
            :key="child.id || index"
            :node="child"
            :data-field="independentDrawerChildDataField(entry.row.detail, child, index)"
            @row-detail="onRowDetail"
            @filter-change="onFilterChange"
            @update:options="onTableOptionsChange"
            @submit="onFilterSubmit"
            @action="onAction"
          />
        </template>
      </BaseDetailDrawer>
    </BaseContainer>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </div>
</template>

<script>
import BaseCodemirror from '../../BaseCodemirror'
import DashboardScreen from '../../Dashboard/DashboardScreen.vue'
import DashboardNodeRenderer from '../../Dashboard/DashboardNodeRenderer.vue'
import DashboardLazyRef from '../../Dashboard/DashboardLazyRef.vue'
import BaseDetailDrawer from '../../Dashboard/BaseDetailDrawer.vue'
import BaseDatePicker from '../../BaseDatePicker'
import { mapActions, mapState } from "vuex"
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import DashboardIndependentDrawers from '../../../mixins/DashboardIndependentDrawers'
import DashboardActionDispatch from '../../../mixins/DashboardActionDispatch'
import BaseSnackbar from '../../BaseSnackbar'

export default {
  name: 'DeveloperDashboardPreview',
  components: { BaseCodemirror, DashboardScreen, DashboardNodeRenderer, DashboardLazyRef, BaseDetailDrawer, BaseDatePicker, BaseSnackbar },
  mixins: [BaseSnackbarConfiguration, DashboardIndependentDrawers, DashboardActionDispatch],
  data() {
    return {
      jsonInput: '',
      modelScreen: 'v-home',
      modelReferenceDate: ''
    }
  },
  computed: {
    ...mapState({
      programInitiator: state => state.platformProgram.programInitiator,
    }),
    baseScreen() {
      if (!this.jsonInput.trim()) {
        return null
      }
      try {
        return JSON.parse(this.jsonInput)
      } catch (e) {
        return null
      }
    },
    parseError() {
      if (!this.jsonInput.trim()) {
        return null
      }
      try {
        JSON.parse(this.jsonInput)
        return null
      } catch (e) {
        return e.message
      }
    }
  },
  methods: {
    ...mapActions(["apiGetScreenList", "apiGetProgramInfo"]),
    async getScreenList(){
      try {
        if (!this.programInitiator) {
          await this.apiGetProgramInfo()
        }
        let result = await this.apiGetScreenList({screen: this.modelScreen, programId: this.programInitiator, date: this.modelReferenceDate })
        this.jsonInput = this.stringifyValue(result)
      } catch (error) {
        const missingParams = error.response && error.response.status === 400 && error.response.data && error.response.data.missingParams
        this.showFeedback({
          color: "error",
          message: Array.isArray(missingParams) && missingParams.length
            ? `Parâmetros obrigatórios faltando: ${missingParams.join(', ')}.`
            : 'Erro ao buscar tela.',
        })
      }
    }
  }
}
</script>
